import React from "react";
import { Helmet } from "react-helmet";
import GlobalLayout from "components/page/GlobalLayout";
import AlarmMonitoringPage from "components/alarms/updated/AlarmMonitoringPage";

export default function AlarmMonitoring() {
  return (
    <GlobalLayout color="var(--gradient-light)">
      <Helmet>
        <title>
          Smart Commercial Alarm Monitoring Systems with Live Agent Support |
          Rhombus
        </title>
        <meta
          name="description"
          content="Rhombus offers robust, smart commercial alarm monitoring with AI threat detection, real-time verification, and rapid response. Start a free trial today!"
        />
        <meta
          name="thumbnail"
          content="https://rhombus.com/img/MetaTag-alm.png"
        />
        <meta
          property="og:image"
          content="https://rhombus.com/img/MetaTag-alm.png"
        />
      </Helmet>
      <AlarmMonitoringPage />
    </GlobalLayout>
  );
}
